import {
  ChangeDetectorRef,
  Component,
  inject,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import { MedecinListComponent } from '../medecin-list/medecin-list.component';
import { HeaderComponent } from '../../header/header.component';
import { TuiButton, TuiIcon, TuiLoader, TuiSurface } from '@taiga-ui/core';
import { TuiCardLarge, TuiHeader } from '@taiga-ui/layout';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  TuiInputModule,
  TuiSelectModule,
  TuiTextfieldControllerModule,
} from '@taiga-ui/legacy';
import { UserService } from '../../services/user.service';
import { AuthService } from '../../services/auth.service';
import { Role, RoleList } from '../../models/role';
import {
  TuiDataListWrapperComponent,
  tuiItemsHandlersProvider,
} from '@taiga-ui/kit';
import { RoleService } from '../../services/role.service';
import { Qualification } from '../../models/qualifications';

@Component({
  selector: 'app-medecin-list-page',
  standalone: true,
  imports: [
    MedecinListComponent,
    HeaderComponent,
    TuiSurface,
    TuiHeader,
    TuiCardLarge,
    TuiButton,
    ReactiveFormsModule,
    TuiInputModule,
    TuiLoader,
    TuiTextfieldControllerModule,
    TuiDataListWrapperComponent,
    TuiSelectModule,
  ],
  templateUrl: './medecin-list-page.component.html',
  styleUrl: './medecin-list-page.component.scss',
  providers: [
    tuiItemsHandlersProvider({
      stringify: (item: Role) => `${item.name}`,
    }),
  ],
})
export class MedecinListPageComponent implements OnInit {
  private readonly formBuilder = inject(FormBuilder);
  protected readonly authService = inject(AuthService);
  private readonly userService = inject(UserService);
  private readonly roleService = inject(RoleService);
  private readonly cdr = inject(ChangeDetectorRef);

  syncronisationEnCours: WritableSignal<boolean> = signal(false);

  nom0: WritableSignal<string | undefined> = signal(undefined);

  role0: WritableSignal<Role | undefined> = signal(undefined);

  roleList: Role[] = [];

  searchForm!: FormGroup;

  onSubmitForm(): void {
    if (this.searchForm.valid) {
      this.nom0.set(this.searchForm.value.nom);
    }
  }

  synchronisationDesUtilisateurs(): void {
    this.syncronisationEnCours.set(true);
    this.userService.synchronisationDesUtilisateurs().subscribe({
      next: () => {
        location.reload();
      },
    });
  }

  ngOnInit(): void {
    this.searchForm = this.formBuilder.group({
      nom: [''],
      role: [null],
    });

    this.searchForm.get('role')?.valueChanges.subscribe((role: Role | null) => {
      this.role0.set(role ?? undefined);
    });

    this.roleService.pullList().subscribe((roleList: RoleList) => {
      this.roleList = roleList.list;
    });
  }
}
